import React from "react";
import map from "lodash/map";
import CustomNodeWidget from "./CustomNodeWidget";

export default class CustomNodeLayerWidget extends React.Component {
    /**
     * Normal node layer widget
     * @module CustomNodeLayerWidget
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidUpdate(){
        this.props.diagramEngine.nodesRendered = true;
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        var diagramModel = this.props.diagramEngine.getDiagramModel();
        return (
            <div
                className="node-view"
                style={{
                    transform:
                    "translate(" +
                    diagramModel.getOffsetX() +
                    "px," +
                    diagramModel.getOffsetY() +
                    "px) scale(" +
                    diagramModel.getZoomLevel() / 100.0 +
                    ")",
                    width: "100%",
                    height: "100%"
                }}
            >
                {map(diagramModel.getNodes(), node => {
                    return React.createElement(
                        CustomNodeWidget,
                        {
                            diagramEngine: this.props.diagramEngine,
                            key: node.id,
                            node: node,
                            readOnly: this.props.readOnly,
                            isCommonModule: this.props.isCommonModule
                        },
                        this.props.diagramEngine.generateWidgetForNode(node)
                    );
                })}
            </div>
        );
    }
}
